import { HostListener, Injectable, OnDestroy } from '@angular/core';
import { OfflineService } from '@phdsoft/common';
import { environment } from 'src/environments/environment';
import { DocumentMediaModel } from '@phdsoft/common';
import { Util } from '@phdsoft/common';
import { IconTypes } from '@phdsoft/theme';
import { Store } from '@ngrx/store';
import { DocumentsReduxState } from '../documents-redux/documents-redux.state';
import { DocumentsReduxActions } from '../documents-redux/documents-redux.reducer';
import { AssetService } from '../../../shared/services/asset.service';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DocumentsListService implements OnDestroy {
  public documentsList: DocumentMediaModel[] = null;
  public iconTypes: IconTypes = new IconTypes();

  constructor(
    private assetService: AssetService,
    private documentsStore: Store<DocumentsReduxState>,
    private readonly offlineService: OfflineService,
    private http: HttpClient
  ) { }

  @HostListener('unloaded')
  ngOnDestroy(): void {
    console.log('💣 Destroy Docs Store');
    this.documentsStore.next(null);
    this.documentsStore.complete();
  }

  async deleteImage(imageId: string): Promise<DocumentMediaModel> {
    const responseData = await this.http.delete<DocumentMediaModel>(
      environment.API_MEDIA + `Media/${imageId}`
    );
    if (this.documentsList.length) {
      this.documentsList = this.documentsList.filter(x => x.Id ? x.Id !== imageId : x.id !== imageId);
      this.documentsStore.dispatch({
        type: DocumentsReduxActions.LIST_DOCUMENTS,
        payload: this.documentsList,
      });
    }

    return responseData;
  }

  stop(): void {
    this.documentsList = null;
  }

  private async getAssetId(): Promise<string> {
    await this.assetService.getCurrentAsset();
    return this.assetService.assetId;
  }

  public async getChecklistAtachments(checkListId: string): Promise<DocumentMediaModel[]> {
    let documentsList;
    documentsList = await this.getAssetDocuments();
    const imageList = documentsList.filter(doc => doc.CheckListId === checkListId);
    return imageList;
  }

  public async getAssetDocuments(assetId?: string): Promise<DocumentMediaModel[]> {
    let _ASSET_ID: any = assetId;

    if (!assetId) {
      _ASSET_ID = await this.getAssetId();
      assetId = _ASSET_ID;
    }

    if (!window.navigator.onLine){
      let dbStoreData = await this.offlineService.getItem(`documentsList_${assetId}`);
      this.documentsList = dbStoreData?.json
    }
    else{
      // const _PARAMS = _ASSET_ID ? new HttpParams().set('pAssetId', _ASSET_ID) : null;
      this.documentsList = await firstValueFrom(this.http.get<DocumentMediaModel[]>(
        environment.API_MEDIA + `Media/GetAssetMediaSecureUrls/${_ASSET_ID}`
      ));
    }

    if (!Util.isNullOrUndefined(this.documentsList) && !((this.documentsList as any).InnerError)) {
      this.updateIcons();

      if (assetId) {
        this.documentsStore.dispatch({
          type: DocumentsReduxActions.LIST_DOCUMENTS,
          payload: this.documentsList,
        });
        if (!this.assetService.asset) {
          this.assetService.asset = { AssetId: _ASSET_ID };
        }
        this.assetService.asset.AssetDocInfo = this.documentsList;
        // await this.assetService.saveCurrentAsset(this.assetService.asset);
      }
    }
    else {
      return null;
    }

    return this.documentsList;
  }

  public updateIcons(): void {
    this.documentsList.forEach((doc) => {
      doc = Object.assign(this.updateIcon(doc));
    });
  }

  public updateIcon(document: DocumentMediaModel): DocumentMediaModel {
    if (Util.isYoutube(document.BlobPath)) {
      document.DocumentType = 'youtube';
      document.BlobPath = Util.youtubeRegex(document.BlobPath);
    }
    document.Icon = this.iconTypes.types(document.DocumentType);
    return document;
  }
}
